import { ValidationError, FetchFailedError, ErrorCode } from './apiError';
import { isLeft } from 'fp-ts/lib/Either';
import { RawApi } from '.';
import { cricketScorecard } from './validators/cricket';
import { SportEvent } from '@/components/Sport/types';
import { CricketTable, cricketLogsApiResponse } from './validators/cricket_logs';

export interface CricketAPI {
  fetchCricketMatchScorecard: (eventId: string) => Promise<SportEvent>;
  fetchCricketLogs: (slug: string) => Promise<CricketTable>;
}

export class CricketApi extends RawApi implements CricketAPI {
  public async fetchCricketMatchScorecard(
    eventId: string,
  ): Promise<SportEvent> {
    const endpoint = `/cricket/v5/icc/scorecard/${eventId}`;
    return this.fetchSportEvent(endpoint);
  }

  public async fetchCricketLogs(
    slug: string,
  ): Promise<CricketTable> {
    const response = await this.fetchScoresApi(`/cricket/v5/icc/logs/team/${slug}`);
    if (!response.ok) {
      throw new FetchFailedError(response.statusText, response.status as ErrorCode, response);
    }
    const jsonResponse: unknown = await response.json();
    const tableLogs = cricketLogsApiResponse.decode(jsonResponse);
    if (isLeft(tableLogs)) {
      throw new ValidationError('API Response validation failed', 400, tableLogs);
    }
    return tableLogs.right;
  }

  private async fetchSportEvent(endpoint: string): Promise<SportEvent> {
    const response = await this.fetchScoresApi(endpoint);

    if (!response.ok) {
      throw new FetchFailedError(response.statusText, response.status as ErrorCode, response);
    }

    const jsonResponse: unknown = await response.json();
    const sportEvent = cricketScorecard.decode(jsonResponse);

    if (isLeft(sportEvent)) {
      throw new ValidationError('API Response validation failed', 400, sportEvent);
    }

    return sportEvent.right;
  }

}
